import { gsap } from 'gsap'

// const footerBanner = new MovingBanner('.footer-banner')
// footerBanner.play()

// <div class="moving-banner">
//         <?php if ($slides): for ($i = 1; $i <= 4; $i++): ?>
//             <div class="moving-banner-line">
//                 <?php foreach ($slides as $s): ?>
//                     <a href="<?= $s['url'] ?>" target="_blank" class="moving-banner-line-element">
//                         <img src="<?= $s['image']['url'] ?>" alt="<?= $s['image']['alt'] ?>">
//                     </a>
//                 <?php endforeach; ?>
//             </div>
//         <?php endfor; endif; ?>
// </div>

class MovingBanner {

  constructor (container) {
    this.elements = `${container} .moving-banner .moving-banner-line`

    this.banner = gsap.to(this.elements, {xPercent: -100, repeat: -1, duration: 20, ease: "linear"}).totalProgress(0.5);
    gsap.set(this.elements, {xPercent: -50});
    this.pause()
  }

  pause () {
    if(!this.banner) { return false }
    this.banner.pause()
  }

  play () {
    if(!this.banner) { return false }
    this.banner.play()
  }

}
export { MovingBanner }
